import React, { useState, useRef, useEffect } from 'react';
import mainlogo from '../img/SustainabilityProLogo.png';
import defaultCompanyLogo from '../img/lsinextgen_logo.jpg'; // Renamed imported image to 'defaultCompanyLogo'
import { Link } from 'react-router-dom';
import useFetch from '../hooks/useFetch';
import DropdownToggle from 'react-bootstrap/esm/DropdownToggle';

export default function Nav() {
  const userdetails = JSON.parse(localStorage.getItem('userdetails'));
  const storedCompanyLogo = localStorage.getItem('company_logo'); // Renamed 'companylogo' from localStorage
  const { data, isLoading } = useFetch(`users/profile/${userdetails.id}`);

  const [companyLogo, setCompanyLogo] = useState(storedCompanyLogo || defaultCompanyLogo); // Renamed state variable

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    localStorage.removeItem('userdetails');
    localStorage.removeItem('token');
    localStorage.removeItem('permissions');
    localStorage.removeItem('email');
    localStorage.removeItem('company_logo');
    setDropdownOpen(false); // Ensure dropdown closes on logout
  };

  useEffect(() => {
    if (data && data.company_info?.company_logo) {
      setCompanyLogo(data.company_info.company_logo);
    }
  }, [data]);

  const toggleDropdown = () => {
    setDropdownOpen(prev => !prev);
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      closeDropdown();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <header className="navbar navbar-white sticky-top bg-white flex-md-nowrap p-0 shadow">
        <div className="logo-container">
          <a className="logo-link" href="./overview">
            <img src={mainlogo} alt="Main Logo" className="logo" />
          </a>
          <a className="logo-link" href="#">
            <img src={companyLogo} alt="Company Logo" className="logo" />
          </a>
        </div>
        <button
          className="navbar-toggler position-absolute d-md-none collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#sidebarMenu"
          aria-controls="sidebarMenu"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="navbar-nav">
          <div className="nav-item text-nowrap" ref={dropdownRef}>
            <DropdownToggle
              className="btn btn-light"
              onClick={toggleDropdown}
            >
              {data?.user ? `${data.user.firstname} ${data.user.lastname}` : 'User'}
            </DropdownToggle>
            {dropdownOpen && (
              <div
                className="dropdown-menu"
                style={{ position: 'absolute', marginLeft: '88%' }}
              >
                <Link className="dropdown-item" to="editprofile" onClick={closeDropdown}>
                  Edit Profile
                </Link>
                <Link className="dropdown-item" to="changepassword" onClick={closeDropdown}>
                  Change Password
                </Link>
                <Link className="dropdown-item" to="/" onClick={() => { closeDropdown(); handleLogout(); }}>
                  Sign out
                </Link>
              </div>
              
            )}
            
          </div>
        </div>
      </header>
    </>
  );
}
